import script from "./MediumSizedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MediumSizedModal.vue?vue&type=script&setup=true&lang=js"

import "./MediumSizedModal.vue?vue&type=style&index=0&id=bfedc238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfedc238"]])

export default __exports__